import { useContext } from "react";

import { isObjectNotEmpty } from "../../helpers/AppxUtils";
import { TvPlanContext } from "../../contexts/tvplancontext";
import TvPickGroup from "../TvPickGroup";


export default function TvPickMoviePack() {
    const ctx = useContext(TvPlanContext);
    const cfg = ctx.getTvConfig();
    const groups = cfg.picks.groups || [];
    let out = [];

    for (let code of groups) {
        if (code === 'movies') {
            let group = cfg.picks.group[code];

            if (!isObjectNotEmpty(group)) {
                continue;
            }

            let selected = ctx.isServiceSelected(code);
            let onClick = () => ctx.selectServiceClick(code);

            if (selected) {
                onClick = () => ctx.unselectServiceClick(code);
            }

            out.push(
                <TvPickGroup
                    key={`pick-group${code}`}
                    onClick={onClick}
                    selected={selected}
                    code={code}
                />
            );
        }
    }

    return (<div className="tv-pick-list">{out}</div>);
}
